import Navbar from '../components/navbar.svelte'
// import BigPicture from 'bigpicture'
import lozad from 'lozad'

export default {
	init() {
		// JavaScript to be fired on all pages
		let navbarContainer = document.getElementById('navbar_container')
		navbarContainer &&
			new Navbar({
				target: navbarContainer,
			})

		let $mobileNavItems = $("ul[role='menu'] li")
		if ($mobileNavItems.length) {
			$mobileNavItems.each(function () {
				$(this).attr('role', 'menuitem')
			})
		}

		let $lazyLoadEls = $('.lozad')
		if ($lazyLoadEls.length) {
			let observer = lozad()
			observer.observe()
		}
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		// let $article = $('article.main-content')
		// // article enlarge images
		// if ($article.length) {
		// 	$article
		// 		.find(
		// 			'.wp-block-image a[href*=".jpg"], .wp-block-image a[href*=".jpeg"]'
		// 		)
		// 		.on('click', function (e) {
		// 			const $this = $(this)
		// 			const $imgEls = $this.find('img')
		// 			e.preventDefault()
		// 			BigPicture({
		// 				el: $imgEls.length ? $imgEls[0] : this,
		// 				imgSrc: this.href,
		// 			})
		// 		})
		// }
		// let $blocksGallery = $('.blocks-gallery-item > figure > a')
		// if ($blocksGallery.length) {
		// 	let $caption = $('.blocks-gallery-item__caption')
		// 	if ($caption) {
		// 		$caption.each(function () {
		// 			$(this).siblings('a')[0].setAttribute('data-caption', $(this).text())
		// 		})
		// 	}
		// 	$blocksGallery.each(function (index, el) {
		// 		el.setAttribute('data-bp', el.href)
		// 	})
		// 	$blocksGallery.on('click', function (e) {
		// 		e.preventDefault()
		// 		BigPicture({
		// 			el: this,
		// 			gallery: '.wp-block-gallery',
		// 			loop: true,
		// 		})
		// 	})
		// }
		// let $wpBlockImg = $('.wp-block-image')
		// if ($wpBlockImg.length) {
		// 	$wpBlockImg.on('click', function (e) {
		// 		const $this = $(this)
		// 		const $imgEls = $this.find('img')
		// 		e.preventDefault()
		// 		BigPicture({
		// 			el: $imgEls.length ? $imgEls[0] : this,
		// 			imgSrc: this.href,
		// 		})
		// 	})
		// }
		// let $wpMediaTxtBlockImg = $('.fusion-imageframe > img')
		// if ($wpMediaTxtBlockImg.length) {
		// 	$('.fusion-imageframe').on('click', function (e) {
		// 		const $this = $(this)
		// 		const $imgEls = $this.find('img')
		// 		e.preventDefault()
		// 		BigPicture({
		// 			el: $imgEls.length ? $imgEls[0] : this,
		// 			imgSrc: this.href,
		// 		})
		// 	})
		// }
	},
}
